import styles from './PageSubtitleRow.module.scss';

interface PageSubtitleRowProps {
    subtitle: string;
}

export default function PageSubtitleRow(props: PageSubtitleRowProps) {
    const { subtitle } = props;

    return (
        <div className={styles.pageSubtitleRow}>
            <div>{subtitle}</div>
        </div>
    );
}
